export const toDealStatuses = statuses => {
  return statuses.map(status => ({
    value: status.id,
    label: status.name,
    code: status.code
  }))
}

export const toStatusesOptions = (statuses, dealStatuses) => {
  if (!dealStatuses.length || !statuses.length) {
    return []
  }
  return statuses.map(status => {
    const dealStatus = dealStatuses.find(dealStatus => dealStatus.value === status)
    return {
      value: dealStatus.value,
      label: dealStatus.label,
      code: dealStatus.code
    }
  })
}
